/* eslint-disable */
import _ from 'underscore';
import ko from 'knockout';
import config from '@bingads-webui-component-legacy/config/index';
import adSchedulingOptions from '@bingads-webui-campaign-legacy/adextension-shared/viewmodel/adSchedulingOptions';
import * as _preferencesService from '@bingads-webui-component-legacy/preference/service/index';
import timeZoneMapper from '@bingads-webui-component-legacy/timezonemapper/index';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextension/shared');
var preferencesService = _preferencesService.default || _preferencesService;
function DayTimeViewModel(days, startHour, startMinute, endHour, endMinute) {
  this.days = ko.observable(days);
  this.startHour = ko.observable(startHour);
  this.startMinute = ko.observable(startMinute);
  this.endHour = ko.observable(endHour);
  this.endMinute = ko.observable(endMinute);
  this.endHour.subscribe(function (newValue) {
    if (newValue == 24) {
      this.endMinute(0);
    }
  }, this);
  this.endMinute.subscribe(function (newValue) {
    if (this.endHour() == 24 && newValue != 0) {
      this.endHour(0);
    }
  }, this);
  this.schedulingRowErrorMessage = ko.computed(function () {
    var startTime = getMinuteOfTheDay(this.startHour(), this.startMinute());
    var endTime = getMinuteOfTheDay(this.endHour(), this.endMinute());
    if (startTime >= endTime) {
      return i18n.get('AdExtensions_Scheduling_Error_InvalidTimeRange') || 'AdExtensions_Scheduling_Error_InvalidTimeRange';
    }
    return '';
  }, this);
}
var use24HourDisplay = false;
function ViewModel(model) {
  var self = this;
  if (!model) {
    model = {};
  }
  ;
  var dayOptionsByVal = _.indexBy(adSchedulingOptions.dayOptions, 'val');
  var minuteOptionsByVal = _.indexBy(adSchedulingOptions.minuteOptions, 'val');
  var minuteOptionsByStringVal = _.indexBy(adSchedulingOptions.minuteOptions, 'stringVal');
  this.isExpanded = ko.observable(!_.isEmpty(model));
  this.timeDisplayType = ko.observable(use24HourDisplay ? '24-hour' : '12-hour');
  var preference = {
    use24HourDisplay: use24HourDisplay
  };
  this.timeDisplayType.subscribe(function (value) {
    use24HourDisplay = value == '24-hour';
    preference = {
      use24HourDisplay: use24HourDisplay
    };
    preferencesService.setAtUserLevel({
      Name: 'WebApp.CampaignUI.adExtensionScheduling',
      Data: preference
    });
  });
  this.dayOptions = adSchedulingOptions.dayOptions;
  this.startHourOptions = buildHourOptions(adSchedulingOptions.fromHourOptions);
  this.endHourOptions = buildHourOptions(adSchedulingOptions.toHourOptions);
  this.minuteOptions = adSchedulingOptions.minuteOptions;
  this.culture = config.get('culture') || 'en-US';
  this.format = config.get('globalization.datetime.shortDatePattern') || 'M/d/yyyy';
  this.datePickerNavigateToFutureAriaLabel = i18n.get('DatePicker_NavigateToFuture_AriaLabel');
  this.datePickerNavigateToPastAriaLabel = i18n.get('DatePicker_NavigateToPast_AriaLabel');
  this.accountTimeZone = timeZoneMapper.getTimeZoneText(config.get('AccountTimeZone'));
  this.startDate = ko.observable(localDateFromUtc(model.StartDate));
  this.endDate = ko.observable(localDateFromUtc(model.EndDate));
  this.useSearcherTimeZone = ko.observable(model.UseSearcherTimeZone || false);
  this.dayTimeRanges = ko.observableArray(_.map(model.DayTimeRanges, function (range) {
    var startMinuteOption = minuteOptionsByStringVal[range.StartMinute];
    var endMinuteOption = minuteOptionsByStringVal[range.EndMinute];
    return new DayTimeViewModel(range.Day, range.StartHour, startMinuteOption.val, range.EndHour, endMinuteOption.val);
  }));
  this.flattenedDayTimeRanges = ko.computed(function () {
    return _.chain(self.dayTimeRanges()).map(function (dayTimeRange) {
      var dayOption = dayOptionsByVal[dayTimeRange.days()];
      var timeRange = {
        startHour: dayTimeRange.startHour(),
        startMinute: dayTimeRange.startMinute(),
        endHour: dayTimeRange.endHour(),
        endMinute: dayTimeRange.endMinute()
      };
      return _.map(dayOption.days, function (day) {
        return _.extend({
          day: day
        }, timeRange);
      });
    }).flatten().value();
  }, this);
  this.consolidatedDayTimeRanges = ko.computed(function () {
    return consolidateRanges(self.flattenedDayTimeRanges());
  }, this);
  this.schedulingRowsErrorMessage = ko.computed(function () {
    var dtRanges = self.flattenedDayTimeRanges();
    var hasOverlapped = hasOverlappedRanges(dtRanges);
    if (hasOverlapped) {
      return i18n.get('AdExtensions_Scheduling_Error_Overlapping_Schedule');
    }
    var dayCounters = _.reduce(adSchedulingOptions.days, function (memo, day) {
      memo[day] = 0;
      return memo;
    }, {});
    for (var i = 0; i < dtRanges.length; i++) {
      var currentDt = dtRanges[i];
      if (++dayCounters[currentDt.day] > 7) {
        return i18n.get('AdExtensions_Scheduling_Error_CannotHaveMoreThanSevenPerDay') || 'AdExtensions_Scheduling_Error_CannotHaveMoreThanSevenPerDay';
      }
    }
    return '';
  }, this);
  this.dateRangeErrorMessages = ko.computed(function () {
    var messages = [];
    var rawStartDate = self.startDate();
    var startDate = parseDate(rawStartDate);
    var rawEndDate = self.endDate();
    var endDate = parseDate(rawEndDate);
    if (endDate && startDate && startDate > endDate) {
      messages.push(i18n.get('AdExtensions_Scheduling_Error_InvalidDateRange') || 'AdExtensions_Scheduling_Error_InvalidDateRange');
    }
    if (_.isString(rawStartDate) && rawStartDate.length > 0) {
      messages.push(i18n.get('AdExtension_Scheduling_StartDateInvalid') || 'AdExtension_Scheduling_StartDateInvalid');
    }
    if (_.isString(rawEndDate) && rawEndDate.length > 0) {
      messages.push(i18n.get('AdExtension_Scheduling_EndDateInvalid') || 'AdExtension_Scheduling_EndDateInvalid');
    }
    return messages;
  }, this);
  this.toObject = function () {
    var dayTimeRanges = _.map(this.consolidatedDayTimeRanges(), function (range) {
      return {
        Day: range.day,
        StartHour: range.startHour,
        StartMinute: minuteOptionsByVal[range.startMinute].stringVal,
        EndHour: range.endHour,
        EndMinute: minuteOptionsByVal[range.endMinute].stringVal
      };
    });
    var startDate = parseDate(this.startDate());
    var endDate = parseDate(this.endDate());
    if (!startDate && !endDate && !dayTimeRanges.length) {
      return {};
    }
    return {
      StartDate: formatDate(startDate),
      EndDate: formatDate(endDate),
      UseSearcherTimeZone: this.useSearcherTimeZone(),
      DayTimeRanges: dayTimeRanges
    };
  };
  this.onRemovingSchedulingRow = function (index) {
    this.dayTimeRanges.splice(index(), 1);
  };
  this.addDayTimeRange = function () {
    this.dayTimeRanges.push(new DayTimeViewModel(this.dayOptions[0].val, 0, 0, 24, 0));
  };
  this.validate = function () {
    return this.dateRangeErrorMessages().length === 0 && this.schedulingRowsErrorMessage() === '' && this.dayTimeRanges().every(function (dayTimeRange) {
      return dayTimeRange.schedulingRowErrorMessage() === '';
    });
  };
  this.originalModelJSON = JSON.stringify(this.toObject());
  this.modelChanged = function () {
    var newModelJSON = JSON.stringify(this.toObject());
    return newModelJSON !== this.originalModelJSON;
  };
  function buildHourOptions(hourOptions) {
    return _.map(hourOptions, function (hourOption) {
      var observableOption = _.extend({}, hourOption);
      observableOption.displayName = ko.computed(function () {
        return self.timeDisplayType() === '12-hour' ? this.twelveHourDisplay : this.twentyFourHourDisplay;
      }, observableOption);
      return observableOption;
    });
  }
  function consolidateRanges(dayTimeRanges) {
    var last, consolidatedRanges = [], ranges = _.chain(dayTimeRanges).flatten().map(function (range) {
      var dayOfWeek = _.indexOf(adSchedulingOptions.days, range.day);
      var prevDaysMinutes = dayOfWeek * 24 * 60;
      return _.extend({
        weeklyStartTime: prevDaysMinutes + getMinuteOfTheDay(range.startHour, range.startMinute),
        weeklyEndTime: prevDaysMinutes + getMinuteOfTheDay(range.endHour, range.endMinute)
      }, range);
    }).sortBy('weeklyStartTime').value();
    _.each(ranges, function (current) {
      if (last && current.day == last.day && current.weeklyStartTime <= last.weeklyEndTime) {
        if (current.weeklyEndTime > last.weeklyEndTime) {
          last.endHour = current.endHour;
          last.endMinute = current.endMinute;
          last.weeklyEndTime = current.weeklyEndTime;
        }
      } else {
        last = current;
        consolidatedRanges.push(current);
      }
    });
    return consolidatedRanges;
  }
  function hasOverlappedRanges(dayTimeRanges) {
    var last, ranges = _.chain(dayTimeRanges).flatten().map(function (range) {
      var dayOfWeek = _.indexOf(adSchedulingOptions.days, range.day);
      var prevDaysMinutes = dayOfWeek * 24 * 60;
      return _.extend({
        weeklyStartTime: prevDaysMinutes + getMinuteOfTheDay(range.startHour, range.startMinute),
        weeklyEndTime: prevDaysMinutes + getMinuteOfTheDay(range.endHour, range.endMinute)
      }, range);
    }).sortBy('weeklyStartTime').value();
    return _.some(ranges, function (current) {
      if (last && current.day == last.day && current.weeklyStartTime < last.weeklyEndTime && current.weeklyEndTime > last.weeklyStartTime) {
        return true;
      } else {
        last = current;
        return false;
      }
    });
  }
}
;
function parseDate(value) {
  var dateValue = _.isDate(value) ? value : _.isEmpty(value) ? null : new Date(value);
  if (dateValue && isNaN(dateValue.getTime())) {
    dateValue = null;
  }
  return dateValue;
}
function getMinuteOfTheDay(hour, minute) {
  return hour * 60 + minute;
}
function localDateFromUtc(date) {
  var parsed = parseDate(date);
  if (_.isNull(parsed) || _.isUndefined(parsed)) {
    return null;
  }
  var offset = parsed.getTimezoneOffset();
  return new Date(parsed.getTime() + offset * 60000);
}
function formatDate(date) {
  if (!_.isDate(date)) {
    return null;
  }
  var utcDate = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  return new Date(utcDate).toISOString();
}
preferencesService.initialize().then(function () {
  var preference = preferencesService.findByName('WebApp.CampaignUI.adExtensionScheduling') || ({
    Data: {}
  });
  use24HourDisplay = preference && preference.Data && preference.Data.use24HourDisplay || false;
});
export default ViewModel;

